import React from "react";
import css from "./NoContent.module.css";

// A simple styled div to indicate a lack of content (listings, reviews, etc)
export default function NoContent({ text }) {
  return <div className={css.root}>{text}</div>;
}
